import {
  Avatar,
  Box,
  TagColor as Color,
  List,
  Tag,
  Text,
} from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectRoleRoleEnum } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export interface NewProjectRoleRowProps {
  editable: boolean
  deletable: boolean
  role: ProjectManagementProjectRoleRoleEnum
  employeeName: string
  employee: EmployeeForSelectFragmentNoAccess
  onUpdateRow: (
    employee: EmployeeForSelectFragmentNoAccess,
    role: ProjectManagementProjectRoleRoleEnum
  ) => void
  onDeleteRow: (employee: EmployeeForSelectFragmentNoAccess) => void
}

const CreateProjectRoleRow = ({
  editable,
  deletable,
  role,
  employeeName,
  employee,
  onUpdateRow,
  onDeleteRow,
}: NewProjectRoleRowProps) => {
  const getLabel = (): string => {
    switch (role) {
      case 'owner':
        return i18n.t('project_management.roles.owner.title')
      case 'editor':
        return i18n.t('project_management.roles.editor.title')
      case 'viewer':
        return i18n.t('project_management.roles.viewer.title')
      default:
        return ''
    }
  }

  const onUpdate = (newRole: ProjectManagementProjectRoleRoleEnum) => {
    onUpdateRow(employee, newRole)
  }

  return (
    <List.Item key={employee.id}>
      <Box flexDirection="row" justifyContent="spaceBetween" width="full">
        <Box flexDirection="row">
          <Avatar size="s24" url={buildUrl(employee.access.avatar)} label={employee.fullName} />
          <Box paddingLeft="s24">
            <Text.Normal weight="medium">{employeeName}</Text.Normal>
          </Box>
        </Box>
        {editable || deletable ? (
          <PopoverMenu type="list">
            <PopoverMenu.Trigger>
              <Tag rightItem="dropdown" inline showActionIcon type={Color.malibu}>
                {getLabel()}
              </Tag>
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="end">
              {editable && (
                <>
                  <PopoverMenu.TouchableOption
                    onClick={() => {
                      onUpdate('owner')
                    }}
                    title={i18n.t('project_management.roles.owner.title')}
                    description={i18n.t('project_management.roles.owner.description')}
                  />
                  <PopoverMenu.TouchableOption
                    onClick={() => {
                      onUpdate('editor')
                    }}
                    title={i18n.t('project_management.roles.editor.title')}
                    description={i18n.t('project_management.roles.editor.description')}
                  />
                  <PopoverMenu.TouchableOption
                    onClick={() => {
                      onUpdate('viewer')
                    }}
                    title={i18n.t('project_management.roles.viewer.title')}
                    description={i18n.t('project_management.roles.viewer.description')}
                  />
                </>
              )}
              {deletable && (
                <PopoverMenu.TouchableOption
                  onClick={() => {
                    onDeleteRow(employee)
                  }}
                  title={i18n.t('common.remove')}
                  danger
                />
              )}
            </PopoverMenu.Content>
          </PopoverMenu>
        ) : (
          <Box justifyContent="center">
            <Tag inline type={Color.malibu}>
              {getLabel()}
            </Tag>
          </Box>
        )}
      </Box>
    </List.Item>
  )
}

export default CreateProjectRoleRow
